// TransactionsTable.jsx
import React, {useMemo, useRef, useState} from "react";
import HorizontalScrollbar from "./HorizontalScrollbar";
import {App, Button, Input, Modal, Tooltip} from "antd";
import {formatUtc} from "../exchange/v1/utils/time";


function Th({children, className = ""}) {
  return (
    <th className={`px-4 py-4 text-left font-bold ${className}`}>{children}</th>
  );
}

function Td({children, className = ""}) {
  return <td className={`px-4 py-4 text-[15px] ${className}`}>{children}</td>;
}

function formatMoney(v) {
  const abs = Math.abs(v).toLocaleString("en-US", {minimumFractionDigits: 2});
  return `${v < 0 ? "-" : ""}${abs}`;
}

const short = (v, n = 10) => (v && v.length > n ? `${v.slice(0, n)}…` : v);

export default function TransactionsTable({rows, amountIcon, amountClassName, loading = false}) {
  const scrollRef = useRef(null);
  const {message} = App.useApp();

  const pageSize = 5;
  const [page, setPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil((rows?.length || 0) / pageSize));

  const pageRows = useMemo(() => {
    const safePage = Math.min(Math.max(page, 1), totalPages);
    const start = (safePage - 1) * pageSize;
    return (rows || []).slice(start, start + pageSize);
  }, [rows, page, totalPages]);

  const canPrev = page > 1;
  const canNext = page < totalPages;

  // const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  // const closePreview = () => {
  //   setPreviewOpen(false);
  //   setPreviewUrl(null);
  // };
  //
  // const openPreview = (url) => {
  //   if (!url) return;
  //   setPreviewUrl(url);
  //   setPreviewOpen(true);
  // };
  //
  // const isImageUrl = (url) => {
  //   if (!url) return false;
  //   const u = String(url).toLowerCase();
  //   return (
  //     u.match(/\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/) ||
  //     u.includes("image") ||
  //     u.includes("img")
  //   );
  // };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      message.success(`Скопировано: ${text}`);
    } catch {
      message.error("Не удалось скопировать");
    }
  };
  // const copyUrl = async () => {
  //   if (!previewUrl) return;
  //   try {
  //     await navigator.clipboard.writeText(previewUrl);
  //     message.success("Ссылка скопирована");
  //   } catch {
  //     message.error("Не удалось скопировать ссылку");
  //   }
  // };
  return (
    <div className="mt-4 rounded-[14px] overflow-hidden border">
      <div ref={scrollRef} className="overflow-x-auto hide-scrollbar">
        <table className="min-w-[760px] md:min-w-full w-full table-fixed">
          <colgroup>
            <col style={{width: "140px"}}/>
            <col style={{width: "160px"}}/>
            <col style={{width: "90px"}}/>
            <col style={{width: "120px"}}/>
            <col style={{width: "110px"}}/>
            <col style={{width: "180px"}}/>
          </colgroup>

          <thead className="bg-[#EEF1F6]">
          <tr>
            <Th>Код</Th>
            <Th>Сумма</Th>
            <Th>Валюта</Th>
            <Th>Отправитель</Th>
            <Th>Баланс</Th>
            <Th className="text-right">Время операции</Th>
          </tr>
          </thead>

          <tbody>
          {pageRows.map((r) => (
            <tr key={r.id} className="border-t">
              <Td className="text-[#5C607C] whitespace-nowrap">
                <Tooltip title={r.code || r.id}>
                  <span
                    onClick={() => copyToClipboard(r.code || r.id)}
                    className="cursor-pointer select-none"
                  >
                    {short(r.code || r.id, 25)}
                  </span>
                </Tooltip>
              </Td>

              <Td className={`${amountClassName} font-semibold whitespace-nowrap`}>
                <div className="flex items-center gap-2">
                  {amountIcon}
                  {formatMoney(r.amount)}
                </div>
              </Td>

              <Td className="text-[#5C607C] whitespace-nowrap">{r?.currency ?? "-"}</Td>
              <Td className="text-[#5C607C] whitespace-nowrap">{r?.sender_name ?? "-"}</Td>
              <Td className="text-[#5C607C] whitespace-nowrap">{r?.balance_after ?? "-"}</Td>

              {/*<Td className="text-[#5C607C]">*/}
              {/*  {r?.url ? (*/}
              {/*    <div className="flex items-center gap-2">*/}
              {/*      <button*/}
              {/*        type="button"*/}
              {/*        onClick={() => openPreview(r.url)}*/}
              {/*        className="flex-1 text-left block truncate text-blue-600 hover:underline"*/}
              {/*        title={r.url}*/}
              {/*      >*/}
              {/*        {r.url}*/}
              {/*      </button>*/}

              {/*    </div>*/}
              {/*  ) : (*/}
              {/*    <span className="block truncate">-</span>*/}
              {/*  )}*/}
              {/*</Td>*/}

              <Td className="text-right text-[#5C607C] whitespace-nowrap">
                {formatUtc(r.occurred_at)}
              </Td>
            </tr>
          ))}

          {pageRows.length === 0 && (
            <tr className="border-t">
              <Td className="text-[#5C607C]" colSpan={5}>
                {loading ? "Загрузка..." : "Нет данных"}
              </Td>
            </tr>
          )}
          </tbody>
        </table>
      </div>

      <HorizontalScrollbar scrollRef={scrollRef}/>

      {totalPages > 1 && (
        <div className="flex items-center justify-end gap-2 px-4 py-3 border-t bg-white">
          <button
            className={`h-[32px] px-3 rounded-md border ${
              canPrev ? "hover:bg-gray-50" : "opacity-50 cursor-not-allowed"
            }`}
            disabled={!canPrev}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
          >
            Назад
          </button>

          <span className="text-[#5C607C] text-[14px] whitespace-nowrap">
            {page} / {totalPages}
          </span>

          <button
            className={`h-[32px] px-3 rounded-md border ${
              canNext ? "hover:bg-gray-50" : "opacity-50 cursor-not-allowed"
            }`}
            disabled={!canNext}
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          >
            Вперёд
          </button>
        </div>
      )}
      {/*<Modal*/}
      {/*  title="Предпросмотр"*/}
      {/*  open={previewOpen}*/}
      {/*  onCancel={closePreview}*/}
      {/*  footer={null}*/}
      {/*  width={900}*/}
      {/*  destroyOnHidden*/}
      {/*>*/}

      {/*  <div className="flex items-center gap-2 mb-4">*/}
      {/*    <Input*/}
      {/*      value={previewUrl || ""}*/}
      {/*      readOnly*/}
      {/*      className="font-mono text-[13px]"*/}
      {/*      onClick={(e) => e.target.select()}*/}
      {/*    />*/}
      {/*    <Button type="primary" onClick={copyUrl}>*/}
      {/*      Скопировать*/}
      {/*    </Button>*/}
      {/*  </div>*/}

      {/*  {!previewUrl ? (*/}
      {/*    <div className="text-[#5C607C]">Нет URL</div>*/}
      {/*  ) : isImageUrl(previewUrl) ? (*/}
      {/*    <div className="w-full">*/}
      {/*      <img*/}
      {/*        src={previewUrl}*/}
      {/*        alt="preview"*/}
      {/*        className="max-h-[70vh] w-full object-contain rounded-md border"*/}
      {/*      />*/}
      {/*      <div className="mt-3">*/}
      {/*        <a*/}
      {/*          href={previewUrl}*/}
      {/*          target="_blank"*/}
      {/*          rel="noopener noreferrer"*/}
      {/*          className="text-blue-600 hover:underline"*/}
      {/*        >*/}
      {/*          Открыть в новой вкладке*/}
      {/*        </a>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  ) : (*/}
      {/*    <div className="w-full">*/}
      {/*      <div className="mb-3">*/}
      {/*        <a*/}
      {/*          href={previewUrl}*/}
      {/*          target="_blank"*/}
      {/*          rel="noopener noreferrer"*/}
      {/*          className="text-blue-600 hover:underline"*/}
      {/*        >*/}
      {/*          Открыть в новой вкладке*/}
      {/*        </a>*/}
      {/*      </div>*/}
      {/*      <iframe*/}
      {/*        title="file-preview"*/}
      {/*        src={previewUrl}*/}
      {/*        className="w-full h-[70vh] rounded-md border"*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*  )}*/}
      {/*</Modal>*/}
    </div>
  );
}